const register = {
  state: {
    show: false,
    path: "/views/main"
  },
  mutations: {
    SET_SHOW: (state, show) => {
      state.show = show
    },
    SET_TO_PATH: (state, path) => {
      state.path = path
    }
  },
  actions: {}
}
export default register
